import React, { FC } from 'react';
import { styled } from 'styled-components';
import { Button } from '../buttons';
import { HelpIcon, HelpIconContainer } from '../helpIconContainer';
import { Icon } from '../icon';
import { Input } from '../input';
import { TextArea } from '../textArea';

const Caption = styled.div`
    margin-bottom: 10px;
    font-size: 12px;
    line-height: 16px;
    color: rgba(68, 90, 100, 1);
`;

const _FormControl: FC<{
    label?: string;
    tooltipLabelHtml?: React.ReactNode;
    className?: string;
    children?: React.ReactNode;
    iconTooltip?: React.ReactNode;
    caption?: React.ReactNode;
    horizontal?: boolean;
    onIconTooltipClick?: () => void;
}> = ({ label, tooltipLabelHtml, caption, className, children, iconTooltip, onIconTooltipClick }) => {
    return (
        <div className={className}>
            {label && (
                <label>
                    <span>{label}</span>
                    {tooltipLabelHtml && (
                        <HelpIconContainer onClick={onIconTooltipClick} tooltip={tooltipLabelHtml}>
                            {iconTooltip || <HelpIcon />}
                        </HelpIconContainer>
                    )}
                </label>
            )}

            {caption && <Caption>{caption}</Caption>}
            <div>{children}</div>
        </div>
    );
};

export const FormControl = styled(_FormControl)`
    width: 100%;

    &:not(:last-child) {
        margin-bottom: 18px;
    }

    > label {
        display: inline-block;
        position: relative;
        margin-bottom: 10px;
        font-size: 14px;
        white-space: nowrap;

        > span {
            vertical-align: middle;
        }

        > ${Icon} {
            cursor: pointer;
            vertical-align: middle;
            position: absolute;
            top: 1px;
        }
    }

    &:has(${Caption}) label {
        margin-bottom: 5px;
    }

    ${Input}, ${TextArea}, ${Button} {
        width: 100%;
    }

    select {
        width: 100%;
    }

    > div {
        clear: both;
        position: relative;
    }
`;

export const FormControlInline = styled(_FormControl)`
    margin-bottom: 10px;
    inline-size: max-content;
    display: inline-block;

    span {
        display: inline-block;
        font-size: 14px;
    }

    label {
        display: block;
        margin-bottom: 20px;
    }

    ${Input}, ${TextArea}, ${Button} {
        width: 100%;
    }
`;

export const SectionControl = styled(_FormControl)`
    display: flex;
    align-items: center;
    padding: 10px 0;
    font-size: 12px;
    min-height: 60px;
    /* padding: 0 1rem 0 0.5rem; */

    label {
        margin-right: auto;
        font-size: 0.9rem;
        display: inline;
    }

    > div {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        > input {
            max-width: 90px;
        }
    }
`;

export const Level = styled.div<{
    align?: 'flex-start' | 'center' | 'flex-end';
    justify?: 'flex-start' | 'center' | 'flex-end';
}>`
    display: flex;
    align-items: ${(props) => props.align || 'center'};
    justify-content: ${(props) => props.justify || 'flex-start'};
`;
